import { scr } from '../../lib/api';
import { useApiQuery } from '../../lib/useApi';
import { ErrorNote, PageHeader, Spinner, StatCard } from '../../ui/components';

interface TsaPositionData {
  settledOut: { amount: string | number; count: number };
  inFlight: { amount: string | number; count: number };
  failed: { amount: string | number; count: number };
  unmatchedStatementLines: number;
}

export function TsaPosition() {
  const q = useApiQuery<TsaPositionData>('/api/v1/payments/tsa/position');

  return (
    <div>
      <PageHeader
        title="Treasury Single Account position"
        subtitle="Government money-out through the Central Bank of Seychelles"
        actions={
          <button className="btn-secondary" onClick={q.reload}>
            Refresh
          </button>
        }
      />
      {q.error ? <ErrorNote message={q.error} /> : null}
      {q.loading ? (
        <Spinner />
      ) : q.data ? (
        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
          <StatCard
            label="Settled out"
            value={scr(q.data.settledOut.amount)}
            hint={`${q.data.settledOut.count} payment(s) confirmed by CBS`}
            tone="good"
          />
          <StatCard
            label="In flight"
            value={scr(q.data.inFlight.amount)}
            hint={`${q.data.inFlight.count} transmitted, awaiting settlement`}
            tone="warn"
          />
          <StatCard
            label="Failed / returned"
            value={scr(q.data.failed.amount)}
            hint={`${q.data.failed.count} instruction(s) bounced`}
            tone="bad"
          />
          <StatCard
            label="Unmatched statement lines"
            value={q.data.unmatchedStatementLines}
            hint="Reconciliation exceptions"
            tone={q.data.unmatchedStatementLines > 0 ? 'warn' : 'default'}
          />
        </div>
      ) : null}
    </div>
  );
}
